<template>
	<InputBase v-bind="attrs" v-on="listeners" v-model="model" onlyNumber />
</template>

<script>
import InputBase from './InputBase.vue';
import numeral from 'numeral';

export default {
	components: {
		InputBase,
	},
	model: {
		prop: 'value',
		event: 'update',
	},
	props: {
		value: Number,
		format: {
			type: String,
			default: '0',
		},
		comma: Boolean,
		maxLength: {
			type: Number,
			default: 15,
			validator(value) {
				return value <= 15;
			},
		},
	},
	data() {
		return {
			localValue: this.value,
			inputOnFocus: false,
		};
	},
	computed: {
		attrs() {
			return {
				...this.$attrs,
				type: 'tel',
			};
		},
		listeners() {
			return {
				...this.$listeners,
				update: () => {},
				keydown: this.onKeydown,
				focus: this.onFocus,
				blur: this.onBlur,
			};
		},

		model: {
			get() {
				if (typeof this.localValue === 'number') {
					if (this.inputOnFocus) {
						return this.localValue.toString();
					}
					return numeral(this.localValue).format(this.comma ? '0,0' : this.format);
				}

				return '';
			},
			set(value) {
				this.localValue = numeral(value).value() || undefined;
			},
		},
	},
	methods: {
		onKeydown(e) {
			if (/([0-9])/.test(e.key)) {
				if (
					String(this.localValue || '').length >= this.maxLength ||
					(Number(e.key) === 0 && e.target.selectionStart === 0)
				)
					e.preventDefault();
			}
		},
		focus() {
			this.$el.querySelectorAll('input,select,textarea')[0]?.focus();
		},
		onFocus() {
			this.inputOnFocus = true;
		},
		onBlur() {
			this.inputOnFocus = false;
		},
	},
	watch: {
		value() {
			this.localValue = this.value;
		},
		localValue() {
			this.$emit('update', this.localValue);
		},
	},
};
</script>
